module.exports = __webpack_public_path__ + "img/icon-level-bronze.d4202d77.png";